import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "preview", "chargerId"];
  static values = { pattern: String };

  connect() {
    this.render();
  }

  render() {
    const typed = this.inputTarget.value.replace(/\s/g, "").toUpperCase();
    const match = typed.match(new RegExp(this.patternValue));

    this.chargerIdTarget.textContent = match ? match[1] : "";
    this.previewTarget.hidden = !match;
  }
}
